var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgValidationCompletionInactive = function SvgValidationCompletionInactive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#D8D8D8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.921 14.278l2.21 2.166L22.5 9.222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.763 15v5.056c0 .797-.66 1.444-1.474 1.444H9.974c-.814 0-1.474-.647-1.474-1.444V9.944c0-.797.66-1.444 1.474-1.444h8.105"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgValidationCompletionInactive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/validation-completion-inactive.ea77dd838a9c5ea0330044338683fdd9.svg";